import React from "react";
import Skeleton from "../../../ui/Skeleton";

export default function LoadingSkeleton() {
  return (
    <div className="space-y-4 sm:space-y-6">
      <div className="grid grid-cols-1 gap-3 sm:gap-4 sm:grid-cols-2 lg:grid-cols-4">
        {[...Array(4)].map((_, i) => (
          <div
            key={i}
            className="rounded-xl sm:rounded-2xl border border-gray-200 bg-white p-4 sm:p-5 shadow-sm dark:border-gray-800 dark:bg-white/[0.03]"
          >
            <Skeleton className="h-8 w-8 sm:h-10 sm:w-10 rounded-full" />
            <div className="mt-3 sm:mt-4">
              <Skeleton className="mb-2 h-5 sm:h-6 w-20 sm:w-24" />
              <Skeleton className="h-3 sm:h-4 w-28 sm:w-32" />
            </div>
          </div>
        ))}
      </div>
      <div className="grid grid-cols-1 gap-4 lg:grid-cols-2">
        {[...Array(2)].map((_, i) => (
          <div
            key={i}
            className="rounded-lg sm:rounded-sm border border-stroke bg-white px-4 sm:px-5 pb-4 sm:pb-5 pt-5 sm:pt-7.5 shadow-default dark:border-strokedark dark:bg-boxdark"
          >
            <Skeleton className="mb-3 h-5 sm:h-6 w-32 sm:w-40" />
            <Skeleton className="h-[250px] sm:h-[350px] w-full" />
          </div>
        ))}
      </div>
    </div>
  );
}
